export default "__VITE_ASSET__tOkWw9sk__"